/* Riegel-Seite: blendet Inhalte je Sorte/Packung ein und wählt Varianten aus den Abschnitten heraus. */
(function () {
  var quelle = document.getElementById('riegel-daten');
  if (!quelle) return;
  var daten;
  try { daten = JSON.parse(quelle.textContent); } catch (e) { return; }

  function alle(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function setze(id) {
    var v = daten.varianten[String(id)];
    if (!v) return;
    var farbe = daten.farben[v.sorte];
    if (farbe) document.documentElement.style.setProperty('--riegel-farbe', farbe);

    alle('[data-riegel-sorte]').forEach(function (n) { n.hidden = n.getAttribute('data-riegel-sorte') !== v.sorte; });
    alle('[data-riegel-packung]').forEach(function (n) { n.hidden = n.getAttribute('data-riegel-packung') !== v.packung; });
    alle('[data-riegel-variante]').forEach(function (n) { n.hidden = n.getAttribute('data-riegel-variante') !== String(id); });

    alle('[data-riegel-karte]').forEach(function (karte) {
      var an = karte.getAttribute('data-riegel-karte') === v.sorte;
      karte.classList.toggle('is-aktiv', an);
      var b = karte.querySelector('[data-riegel-waehle]');
      if (b) {
        b.setAttribute('aria-pressed', an ? 'true' : 'false');
        var t = b.getAttribute(an ? 'data-text-an' : 'data-text-aus');
        if (t) b.textContent = t;
      }
    });
    alle('[data-riegel-box-knopf]').forEach(function (b) {
      b.setAttribute('aria-pressed', v.packung === 'box' ? 'true' : 'false');
      var t = b.getAttribute(v.packung === 'box' ? 'data-text-an' : 'data-text-aus');
      if (t) b.textContent = t;
    });
  }

  function waehle(position, wert) {
    var input = document.querySelector('input[type="radio"][data-option-position="' + position + '"][value="' + wert + '"]');
    if (!input) return false;
    if (!input.checked) input.click();
    return true;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-riegel-waehle]');
    if (!b) return;
    e.preventDefault();
    if (!waehle(b.getAttribute('data-position'), b.getAttribute('data-wert'))) return;
    var ziel = document.getElementById('riegel-kauf');
    if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    setze(e.detail.variant.id);
  });
})();
